
/* ============================== src/components/Gantt/geometry.js ============================== */
// src/components/Gantt/geometry.js
import { parseISO, iso, TODAY } from "../../utils/date";

export const UNKNOWN_PROJECT_ID = "__unknown__";
export const UNKNOWN_PROJECT = {
  id: UNKNOWN_PROJECT_ID,
  code: "-",
  name: "Без проекта",
};

export const isOverdue = (task) =>
  task.deadline &&
  task.deadline < TODAY &&
  task.status !== "closed" &&
  task.status !== "cancelled";

export const normalizeAnchor = (dateStr, modeArg) => {
  const d = parseISO(dateStr);
  if (modeArg === "quarter")
    return iso(new Date(d.getFullYear(), Math.floor(d.getMonth() / 3) * 3, 1));
  if (modeArg === "year") return iso(new Date(d.getFullYear(), 0, 1));
  return iso(new Date(d.getFullYear(), d.getMonth(), 1));
};

const daysBetween = (a, b) =>
  Math.round((parseISO(b) - parseISO(a)) / 86400000);

export const computeTaskIndices = (
  task,
  dayIndexByIso,
  daysLength,
  viewStart,
  viewEnd,
) => {
  const normalizeDate = (s) => (s ? s.slice(0, 10) : "");

  const sRaw = dayIndexByIso.get(normalizeDate(task.start));
  const eRaw = dayIndexByIso.get(normalizeDate(task.deadline));
  let sIdx = sRaw === undefined ? -1 : sRaw;
  let eIdx = eRaw === undefined ? -1 : eRaw;

  if (sIdx === -1 && eIdx === -1) {
    if (task.start < viewStart && task.deadline > viewEnd) {
      sIdx = 0;
      eIdx = daysLength - 1;
    } else return null;
  }
  if (sIdx === -1 && eIdx !== -1) {
    const diff = daysBetween(task.start, task.deadline);
    sIdx = eIdx - diff >= 0 ? eIdx - diff : 0;
  }
  if (eIdx === -1 && sIdx !== -1) {
    const diff = daysBetween(task.start, task.deadline);
    eIdx = sIdx + diff < daysLength ? sIdx + diff : daysLength - 1;
  }
  if (sIdx === -1 || eIdx === -1 || sIdx > eIdx) return null;
  return { sIdx, eIdx };
};

export const computeBarGeometry = (task, indices, DW) => {
  const { sIdx, eIdx } = indices;
  const left = sIdx * DW + 2;
  const width = Math.max((eIdx - sIdx + 1) * DW - 4, DW - 8);
  return { left, width };
};
